import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of, catchError, switchMap, tap } from 'rxjs';
import { ERROR_MESSAGES } from '../constants/error-messages.constants';
import { PermissionService } from '../services/common/permission.service';
import { BaseAuthService } from '../services/common/base-auth.service';

export const pagePermissionGuard: CanActivateFn = (route, state) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);
  const baseAuth = inject(BaseAuthService);

  baseAuth.monitorAuthenticationStatus();

  const pageTarget = route.routeConfig?.path ?? '';
  
  if (pageTarget === 'home') {
    return of(true);
  }

  return permissionService.ensureRoleLoaded().pipe(
    switchMap(_ => {
      if (permissionService.isAdminRole()) {
        return of(true);
      }

      return permissionService.ensurePermissionsLoaded().pipe(
        switchMap(permissions => {
          if (!permissions) {
            router.navigate(['/unauthorized'], { 
              queryParams: { 
                code: 401, 
                message: ERROR_MESSAGES[401],
                returnUrl: state.url
              } 
            });
            return of(false);
          }

          return permissionService.hasPagePermissionAsync(pageTarget, 'read');
        })
      );
    }),
    tap(hasPermission => {
      if (!hasPermission) {
        router.navigate(['/unauthorized'], {
          queryParams: {
            code: 403,
            message: ERROR_MESSAGES[403],
            returnUrl: state.url
          }
        });
      }
    }),
    catchError(error => {
      console.error('Erro ao verificar permissões:', error);
      router.navigate(['/unauthorized'], {
        queryParams: {
          code: 500,
          message: ERROR_MESSAGES[500],
          returnUrl: state.url
        }
      });
      return of(false);
    })
  );
};